module.exports = __webpack_public_path__ + "img/samsung-galaxy-note8.ef2225c6.png";